export const FLAG_GETTING_EVENTS = 'FLAG_GETTING_EVENTS';
export const GET_EVENTS = 'GET_EVENTS';
export const CLEAR_EVENTS = 'CLEAR_EVENTS';
export const FLAG_EVENT_ACTIVITY = 'FLAG_EVENT_ACTIVITY';
export const GET_EVENT = 'GET_EVENT';
export const CLEAR_EVENT = 'CLEAR_EVENT';
